import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/dashboard/Index"),
      children: [
        {
          name: "Tizimga kirish",
          path: "",
          component: () => import("@/views/dashboard/Login"),
        },
        {
          name: "Imtixon",
          path: "/exam-page/:id",
          component: () => import("@/views/dashboard/ExamPage"),
        },
        {
          name: "Natija",
          path: "/result-history/:id",
          component: () => import("@/views/dashboard/ResultHistory"),
        },
        {
          name: "Imtixonlar",
          path: "/table/exam/:id",
          component: () => import("@/views/dashboard/ExamTable"),
        },
        {
          name: "Oliygoh",
          path: "/table/university",
          component: () =>
            import("@/views/dashboard/UniversityTable"),
        },
        {
          name: "Fakultet",
          path: "/table/faculty/:id",
          component: () => import("@/views/dashboard/FacultyTable"),
        },
        {
          name: "Fakultet",
          path: "/table/faculty/",
          component: () => import("@/views/dashboard/FacultyTable"),
        },
        {
          name: "Yo'nalish",
          path: "/table/direction/:id",
          component: () => import("@/views/dashboard/DirectionTable"),
        },
        {
          name: "Guruh",
          path: "/table/group/:id",
          component: () => import("@/views/dashboard/GroupTable"),
        },
        {
          name: "Fan",
          path: "/table/subject/:id",
          component: () => import("@/views/dashboard/SubjectTable"),
        },
        {
          name: "Fan",
          path: "/table/subject",
          component: () => import("@/views/dashboard/SubjectTable"),
        },
        {
          name: "Foydalanuvchi",
          path: "/table/user/:id",
          component: () => import("@/views/dashboard/UserTable"),
        },
        {
          name: "Natija",
          path: "/table/result/:id",
          component: () => import("@/views/dashboard/ResultTable"),
        },
        {
          name: "Savol",
          path: "/table/quiz/:id",
          component: () => import("@/views/dashboard/QuizTable"),
        },
        {
          name: "Create new Group",
          path: "/table/group/create",
          component: () => import("@/views/dashboard/GroupCreate"),
        },
        // Pages
        {
          name: "User Profile",
          path: "pages/user",
          component: () =>
            import("@/views/dashboard/pages/UserProfile"),
        },
      ],
    },
  ],
});
